import React from 'react';
import './FlexSearchSave.scss';
import { connect } from 'react-redux';
import * as actions from "store/actions/index";
import { isPorscheArchiv } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';
import Modal from "Flow2/components/AdvancedBox/AdvancedUI/Modal/Modal.js";
import AdvancedBox from 'Flow2/components/AdvancedBox/AdvancedBox/AdvancedBox';
import * as aTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/AdvancedTypes';
import FormInput from "Flow2/components/AdvancedBox/AdvancedUI/FormInput/FormInput";
import { faSave, faPlus, faUndo, faEdit } from '@fortawesome/free-solid-svg-icons';
import Dropdown from "Flow2/components/AdvancedBox/AdvancedUI/Dropdown/Dropdown";
import Button from "Flow2/components/AdvancedBox/AdvancedUI/Button/Button";

class FlexSearchSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSaveBox: false,
            userInputs: {},
            errors: {},
            searchedFlexList: [],
            targetFields: [],
            searchedFlexListCur: null
        };
    }

    fm = (id) => this.props.intl.formatMessage({ id });

    initData = () => {
        const { searchedFlexList } = this.props.flexObjects;
        if (!searchedFlexList || !searchedFlexList.length) {
            const expertsearchpresets = this.props.user.granting.udo.expertsearchpresets;
            if (expertsearchpresets && expertsearchpresets.length) {
                this.setState({
                    searchedFlexList: [
                        { ...aTypes.DD_SELECT },
                        ...expertsearchpresets
                    ]
                });
                this.props.updateFlexObjects({ searchedFlexList: [...expertsearchpresets] });
            }
        } else {
            this.setState({ searchedFlexList: [{ ...aTypes.DD_SELECT }, ...searchedFlexList] });
        }
    }

    updateData = () => {
        if (this.props.flexObjects && this.props.flexObjects.searchedFlexList) {
            this.setState({
                searchedFlexList: [
                    { ...aTypes.DD_SELECT },
                    ... this.props.flexObjects.searchedFlexList,
                ]
            });
        }
    }

    onSaveDlgInput = (e, name) => {
        this.setState({ userInputs: { ...this.state.userInputs, [name]: e.target.value } });
    }

    onCloseMsgDlg = () => {
        this.setState({ saveDlgOpened: false, modalOpened: false });
    }

    onSaveBtn = () => {
        this.setState({ saveDlgOpened: true, modalOpened: true });
    }

    onLoadBtn = () => {
        if (this.state.currentFlexSearchSave) {
            this.props.updateFlexObjects({ currentFlexSearchSave: this.state.currentFlexSearchSave });
        }
    }

    saveListData = ({ list }) => {
        this.props.updateFlexObjects({ searchedFlexList: list });
        this.props.saveUserSearchData({
            user: { id: this.props.user.id, groupid: this.props.user.groupid },
            option: aTypes.EXPERT_PRE, data: list
        });
    }

    onEditBtn = () => {
        let list = [];
        const { searchedFlexList } = this.props.flexObjects;
        if (this.state.userInputs && this.state.searchedFlexListCur && searchedFlexList) {
            let found = searchedFlexList.find(item => item.value == this.state.searchedFlexListCur.value);
            let newItem;
            if (found) {
                const searchData = this.props.onFlexSearchSaveList();
                newItem = { ...found, searchData };
                let index = searchedFlexList.findIndex(item => item.value == this.state.searchedFlexListCur.value);
                list = [...searchedFlexList];
                list[index] = newItem;
                this.saveListData({ list });
                this.setState({ userInputs: { ...this.state.userInputs } });
            }
        }
    }

    onSaveDlg = () => {
        let list = [];
        const { searchedFlexList } = this.props.flexObjects;
        if (this.state.userInputs && this.state.userInputs.savedSearch) {
            let name = this.state.userInputs.savedSearch;
            if (name) {
                const searchData = this.props.onFlexSearchSaveList();
                let newItem = {
                    name, intl: name, value: `savedItem_${Date.now()}`,
                    searchData, userInputs: { ...this.state.userInputs }
                };
                if (searchedFlexList) list = [...searchedFlexList, newItem];
                else list.push(newItem);
                this.saveListData({ list });
                this.setState({
                    modalOpened: false, saveDlgOpened: false,
                    userInputs: { ...this.state.userInputs, savedSearch: '' }
                });
            }
        }
    }

    onDDSearchedList = (el) => {
        this.setState({ currentFlexSearchSave: el, searchedFlexListCur: el });
    }

    onDDSearchedListDelete = (el) => {
        let list = [];
        const { searchedFlexList } = this.props.flexObjects;
        if (searchedFlexList) {
            list = searchedFlexList.filter(item => item.value !== el.value);
            if (this.state.searchedFlexListCur && this.state.searchedFlexListCur.value === el.value) {
                this.setState({ targetFields: [], searchedFlexListCur: null });
            }
        }
        this.saveListData({ list });
    }

    closeModal = () => {
        this.setState({ modalOpened: false, saveDlgOpened: false });
    }

    showSaveDialog = () => {
        return (
            <div className="flexsave-save-form">
                {aTypes.SAVEDLG_ITEMS.map((el, idx) => {
                    return (
                        <FormInput name={el.name} key={`flexsave_input_${idx}`} type="text"
                            value={this.state.userInputs[`${el.name}`] || ""}
                            error={this.state.errors[`${el.name}`]} placeholder={this.fm(el.intl)}
                            onChange={(e) => this.onSaveDlgInput(e, el.name)} required={el.required} />
                    )
                })}
                <Button className="flexsave-save-btn" onClick={this.onSaveDlg}>
                    <FontAwesomeIcon icon={faSave} />
                    {this.fm("advanced.save")}
                </Button>
            </div>
        )
    }

    showTop = () => {
        return (
            <div className="flexsave-top">
                <div className="flexsave-top-content">
                    <div className="flexsave-buff"></div>
                    <div className="flexsave-content-middle">
                        <div className="flexsave-dd">
                            <Dropdown data={this.state.searchedFlexList}
                                current={this.state.searchedFlexListCur}
                                required={false} error={false} isDeleted={true}
                                onDDClick={this.onDDSearchedList} onDDTrashClick={this.onDDSearchedListDelete} />
                        </div>
                    </div>
                    <Button className="flexsave-active" onClick={this.onLoadBtn}>
                        <FontAwesomeIcon icon={faUndo} />
                        <span>{this.props.intl.formatMessage({ id: "advanced.load" })}</span>
                    </Button>
                    <Button onClick={this.onEditBtn}>
                        <FontAwesomeIcon icon={faEdit} />
                        <FontAwesomeIcon icon={faSave} />
                    </Button>
                    <Button onClick={this.onSaveBtn}>
                        <FontAwesomeIcon icon={faSave} />
                        <span>{this.props.intl.formatMessage({ id: "advanced.save" })}</span>
                    </Button>
                    <div className="flexsave-wrapper">
                        {<AdvancedBox />}
                    </div>
                </div>
            </div>
        )
    }

    componentDidUpdate(prev) {
        if (prev.flexObjects.searchedFlexList != this.props.flexObjects.searchedFlexList) {
            this.updateData();
        }

        if (!prev.flexObjects.resetCurrentFlexSearch && this.props.flexObjects.resetCurrentFlexSearch) {
            this.setState({ searchedFlexListCur: null });
            this.props.updateFlexObjects({ resetCurrentFlexSearch: false, currentFlexSearchSave: true });
        }
    }

    componentDidMount() {
        this.initData();
    }

    render() {
        if (isPorscheArchiv()) {
            return (
                <div className="FlexSearchSave">
                    {this.showTop()}
                    {this.props.children}
                    <Modal className="flexsave-modal" open={this.state.modalOpened}
                        onClose={() => this.setState({ modalOpened: false })}>
                        <div className="flexsave-close" onClick={this.closeModal}>
                            <FontAwesomeIcon icon={faPlus} />
                        </div>
                        {this.state.saveDlgOpened && this.showSaveDialog()}
                    </Modal>
                </div>
            )
        }
        return null;
    }
}

const mapStateToprops = (state) => ({
    flexObjects: state.flex.flexObjects,
    user: state.auth.user,
})

const mapDispatchToProps = (dispatch) => ({
    updateFlexObjects: (obj) => dispatch(actions.updateFlexObjects(obj)),
    saveUserSearchData: (obj) => dispatch(actions.saveUserSearchData(obj))
});

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(FlexSearchSave));